import { inject } from './AsyncScriptLoader';

const injectGoogleSignIn = async () =>
  Promise.all([
    inject('https://apis.google.com/js/platform.js'),
    inject('https://accounts.google.com/gsi/client'),
  ]);

export default injectGoogleSignIn;
